import React from 'react';
import Icon from 'chameleon/ui-stack/ui/base/icon';
import IconWithDescription from '../index';

import './styles.scss';

const TeacherRemovedQuestionIcon = () => {
  const label =
    'You have removed this question from your Question Bank. It can no longer be added to a quiz.';

  return (
    <IconWithDescription
      className="teacher_removed_question"
      width="medium"
      btnProps={null}
      trigger={
        <Icon
          name="teacher_removed_question"
          height="20"
          width="20"
          className="alert-icon error"
        />
      }
      popoverAriaLabel="Teacher Removed"
      tooltipAriaLabel={label}
    >
      <span className="">{label}</span>
    </IconWithDescription>
  );
};

TeacherRemovedQuestionIcon.displayName = 'TeacherRemovedQuestionIcon';

export default TeacherRemovedQuestionIcon;
